import {
  TrainerServiceTrainer,
  Request,
} from "@campgladiator/cg-common.types.types";
import { fetchRequest } from "@campgladiator/cg-common.api.fetch-request";
import { getApiGatewayUrl } from "@campgladiator/cg-common.config.config";

type FetchTrainerByNameParams = {
  trainerName: string;
};

type FetchTrainerByIdParams = {
  trainerId: string;
};

export const fetchTrainerByName = async ({
  trainerName,
}: FetchTrainerByNameParams): Promise<TrainerServiceTrainer[]> => {
  const endpoint = "/trainer/v1/trainers";
  const params = `?includeDeleted=false&name=${trainerName}`;
  const method = "GET";

  const request: Request = {
    requestConfig: {
      method,
      url: {
        baseUrl: getApiGatewayUrl(),
        endpoint,
        params,
      },
    },
  };

  const response = await fetchRequest({ request });
  const { content, error } = await response.json();

  return response.ok
    ? (content as TrainerServiceTrainer[])
    : Promise.reject(new Error(error));
};

export const fetchTrainerById = async ({
  trainerId,
}: FetchTrainerByIdParams): Promise<TrainerServiceTrainer> => {
  const endpoint = `/trainer/v1/trainers/${trainerId}`;
  const method = "GET";

  const request: Request = {
    requestConfig: {
      method,
      url: {
        baseUrl: getApiGatewayUrl(),
        endpoint,
      },
    },
  };

  try {
    const response = await fetchRequest({ request });
    const result = await response.json();

    return response.ok ? result : Promise.reject(result);
  } catch (error: any) {
    const errorMessage = error.message || "Processing payment failed";

    throw new Error(errorMessage);
  }
};
